import React from 'react'

/**
 * Margens de página (pedido do cliente, ronda 3 de `fix/easysolutions-arial-justify`):
 * topo 3cm, direita 2cm, base 2cm, esquerda 3cm, em TODAS as páginas do documento.
 *
 * `components/pdf/Page.js` (raiz `#pdfPage`, `padding: 0`) e `printPdf.js` são
 * compartilhados por ~25 marcas — não são tocados aqui para não afetar os demais
 * templates. Também não dá para resolver só com `padding` no container: como o corpo
 * flui por várias páginas impressas (thead/tfoot com `table-header-group`/
 * `table-footer-group` se repetindo a cada página via `Page.js`), padding no container
 * só apareceria no topo da primeira página e na base da última, não em cada página.
 *
 * A mesma técnica de `Footer.js`/`Landscape.js` do bradesco/pgr é usada aqui: CSS Paged
 * Media (`@page { margin }`), suportado pelo motor de impressão do Chromium, aplicado
 * via `<style>` dentro da própria árvore de `#pdfPage` — copiado pelo `print-js` junto
 * com o restante do documento, e escopado somente a este print job (easysolutions).
 */
export const PageMargins = () => (
  <style>{`
    @page {
      margin: 3cm 2cm 2cm 3cm;
    }
  `}</style>
)

export default PageMargins
